<template>

<div class="text" :class="{'is-center': center, 'is-spaced': spaced, 'is-white': white}">

	<slot></slot>

</div>

</template>

<script>

export default {

	props: ['center', 'spaced', 'white']

}

</script>

<style scoped>

.text {
	width: 100%;
}

.text.is-center {
	text-align: center;
}

.text.is-spaced {
	padding-top: 20px;
}

.text >>> h1,
.text >>> h2,
.text >>> p,
.text >>> ol,
.text >>> ul,
.text >>> .message,
.text >>> .group {
	margin-bottom: 20px;
}

.is-mobile .text >>> h1,
.is-mobile .text >>> h2,
.is-mobile .text >>> p,
.is-mobile .text >>> ol,
.is-mobile .text >>> ul,
.is-mobile .text >>> .message,
.is-mobile .text >>> .group {
	margin-bottom: 10px;
}

.text >>> img {
    max-width: 100%;
}

.text >>> ol, 
.text >>> ul {
	list-style-position: outside;
}

.text >>> ol {
	list-style: decimal;
}

.text >>> ul {
	list-style: disc;
}

.text >>> li {
	margin-left: 20px;
}

.text >>> h1 {
    font-family: grueber,serif;
    font-size: 32px;
    line-height: 40px;
    color: var(--color-grey-dark);
    font-family: "grueber",serif;
}

.text >>> h2 {
	font-size: 20px;
    line-height: 24px;
    color: var(--color-grey-dark);
    font-family: "grueber",serif;
}

.is-mobile .text >>> h2 {
    font-size: 16px;
    line-height: 20px;
}

.text >>> p,
.text >>> li {
	font-size: 14px;
    line-height: 20px;
    color: var(--color-grey-dark);
}

.text.is-white >>> h1,
.text.is-white >>> h2,
.text.is-white >>> p,
.text.is-white >>> li {
	color: #fff;
}

.text >>> p.notice {
    text-align: right;
    font-size: 12px;
    font-weight: 300;
}

.text >>> p a {
	font-weight: 500;
    color: var(--color-blue-light);
}

.text.is-white >>> p a {
	font-weight: 500;
	text-decoration: underline;
}

.is-desktop .text >>> p a:hover {
	text-decoration: underline;
}

.is-desktop .text.is-white >>> p a:hover {
	text-decoration: none;
}

.text >>> *:last-child {
	margin-bottom: 0px;
}

</style>